var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconSchool = function SvgIconSchool(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.988,
    height: 37.848,
    viewBox: "0 0 32.988 37.848",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-3220.745-4229.985h-19.935v-21.138h15.078v-7.047l8.456-8.455,8.455,8.455v28.184h-4.752v-13.486h-7.3v13.486Zm-14.35-15.16v5.636h5.636v-5.636Zm18-11.457a3.546,3.546,0,0,0-3.542,3.542,3.546,3.546,0,0,0,3.542,3.542,3.545,3.545,0,0,0,3.541-3.542A3.545,3.545,0,0,0-3217.094-4256.6Z",
    transform: "translate(3241.179 4267.333)",
    fill: "#1c5970",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSchool, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-school.3bb9c4aa.svg";
export { ForwardRef as ReactComponent };